import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Router } from '@angular/router';
import { filter, first, map, startWith, switchMap, timer } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { Empresa } from 'src/app/core/models/auth/Empresa';
import { Usuario } from 'src/app/core/models/auth/Usuario';
import { AuthService } from 'src/app/core/services/auth';
import { LoaderService } from 'src/app/core/services/loader';
import { SharedService } from 'src/app/core/services/shared';
import { UsuarioService } from 'src/app/core/services/usuario';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  authService = inject(AuthService);
  usuarioService = inject(UsuarioService);

  sharedService = inject(SharedService);

  userGivenNameInitial$ = this.authService.accessData$.pipe(
    map((accessData) => accessData?.email[0])
  );

  usuario?: Usuario;

  empresaSelecionada$ = this.authService.empresaSelecionada$;

  empresaControl = new FormControl('', { nonNullable: true });

  empresasFiltradas: Empresa[] = [];

  get empresasDisponiveis() {
    return (
      this.usuario?.respostaEmpresasUsuariosDTO.map(
        (respostaEmpresa) => respostaEmpresa.respostaEmpresaDTO
      ) ?? []
    );
  }

  ngOnInit(): void {
    this.loadUsuarioFromLocalStorage();
    this.registrarFiltroEmpresas();
  }

  toggleSidenav(): void {
    this.sharedService.toggleSidenav();
  }

  displayWithFn = (guidEmpresa?: string): string => {
    const apelido = this.empresasDisponiveis.find(
      (e) => e.guid === guidEmpresa
    )?.apelido;

    return apelido ?? '';
  };

  onChangeEmpresa(event: MatOptionSelectionChange<string>): void {
    const user = this.usuario;

    if (!user) {
      return;
    }

    const guidEmpresa = event.source.value;

    const empresa = this.empresasDisponiveis.find(
      (e) => e.guid === guidEmpresa
    );

    if (!empresa) {
      return;
    }

    this.authService.setSelectedEmpresa(empresa);

    this.refreshOnboardingStatus();

    timer(100)
      .pipe(this.takeUntilDestroyed())
      .subscribe(() => {
        this.empresaControl.setValue('');
      });
  }

  loadUsuario(): void {
    const loaderRef = this.loader.open('Carregando empresas...');

    this.usuarioService
      .obterUsuarioLogado()
      .subscribe((usuario) => {
        this.usuario = usuario;
      })
      .add(() => loaderRef.close());
  }

  private refreshOnboardingStatus(): void {
    const loaderRef = this.loader.open('Carregando onboarding...');

    this.authService
      .loadOnboardingStatus()
      .subscribe(() => {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['inicio']);
          });
      })
      .add(() => loaderRef.close());
  }

  private loadUsuarioFromLocalStorage(): void {
    this.authService.usuario$
      .pipe(first(), filter(Boolean))
      .subscribe((usuario) => {
        this.usuario = usuario;
      });
  }

  private registrarFiltroEmpresas(): void {
    this.empresaControl.valueChanges
      .pipe(startWith(''), this.takeUntilDestroyed())
      .subscribe((filtro) => {
        if (!filtro) {
          this.empresasFiltradas = this.empresasDisponiveis;
          return;
        }

        this.empresasFiltradas = this.empresasDisponiveis.filter((empresa) => {
          return empresa.apelido.toLowerCase().includes(filtro.toLowerCase());
        });
      });
  }
}
